import type { CardPointeIpgConfig } from './cardpointe-backend-config.types';
import { CardPointeRpaModuleName } from './cardpointe-rpa-module-names';
import { CardPointeIpgSystemId } from './cardpointe-system-constants';
import { CardPointeGatewayEnvironment } from './cardpointe-gateway-environment.types';

export const CardPointeIpgConfigProd: CardPointeIpgConfig = {
    ipg_id: CardPointeIpgSystemId,
    environment: CardPointeGatewayEnvironment.PRODUCTION,
    name: 'CardPointe',
    urlPattern: 'https://*.cardpointe.com/*',
    workflow_prefix: 'cardpointe',
    allowedWebsites: [
        {
            type: 'ipg',
            system_id: CardPointeIpgSystemId,
            url: 'https://cardpointe.com',
            name: 'CardPointe Portal',
            allowedUrlPatterns: ['https://*.cardpointe.com/*'],
            sessionPersistence: 'persistent',
            promoteSessionCookies: false,
            urlPatternsRules: [],
            fetchDefaultAction: 'allow',
            iframeUrlPatterns: [],
            iframeDefaultAction: 'allow',
        },
    ],
    rpaModules: [CardPointeRpaModuleName.CARDPOINTE_IPG],
};

export const CardPointeIpgConfigDemo: CardPointeIpgConfig = {
    ...CardPointeIpgConfigProd,
    environment: CardPointeGatewayEnvironment.SANDBOX,
};
